import { FunctionComponent } from "react";
import update from "immutability-helper";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import set from "lodash/set";
import { makeVar, useReactiveVar } from "@apollo/client";

import config from "src/helpers/config";

interface StateValue {
    where: any;
    pagination: PaginationCollectionInput;
    reset?: boolean;
}

interface PaginationCollectionInput {
    limit: number;
    offset: number;
}

const initialValue = {
    where: {},
    pagination: {
        limit: config.PAGINATION_LIMIT,
        offset: 0,
    },
};
const stateVar = makeVar(initialValue);

export const withStateAndActionsForCollection = (
    Component: FunctionComponent,
) => {
    const WithComponent = (props: any) => {
        const state = useReactiveVar(stateVar);

        function updateState({ where, pagination, reset = false }: StateValue) {
            const newState = update(
                state,
                reset
                    ? {
                          where: { $set: {} },
                          pagination: {
                              $set: {
                                  limit: config.PAGINATION_LIMIT,
                                  offset: 0,
                              },
                          },
                      }
                    : {
                          where:
                              isEmpty(where) || !where._and
                                  ? { $set: where }
                                  : {
                                        $merge: omit(where, "_and"),
                                        ...(where._and && {
                                            _and: {
                                                $set: where._and,
                                            },
                                        }),
                                    },
                          pagination: { $merge: pagination },
                      },
            );

            stateVar(newState);
        }
        function onPaginationChange(pagination: PaginationCollectionInput) {
            updateState({ ...state, pagination });
        }
        function onStateReset() {
            updateState({ ...initialValue, reset: true });
        }

        function onNameChange(name: string, passedWhere: any = {}) {
            const path = ["title", "_ilike"];
            const where = set({ ...passedWhere }, path, `%${name}%`);
            updateState({
                ...state,
                where,
                pagination: { ...state.pagination, offset: 0 },
            });
        }

        return (
            <Component
                {...{
                    // State
                    ...state,

                    // State Actions
                    onPaginationChange,
                    onStateReset,
                    onNameChange,
                }}
                {...props}
            />
        );
    };
    return WithComponent;
};

export default {
    read() {
        return stateVar();
    },
};
